<template>
    <v-container class="bg-white rounded-2 h-100 d-flex align-center justify-center">
        <v-col cols="11" sm="8" class="card-content text-center"
               :style="$vuetify.breakpoint.smAndDown && 'font-size: 15px'">
            <h3 class="pb-4">
                Cadastro realizado com sucesso!
            </h3>
            <span>
                Agora seu cadastro entrará em uma fila de aprovação, que é feita pelo nosso time especializado em hotelaria.
                Se ele for aprovado, logo novas solicitações de reservas irão chegar para vocês por meio do email e WhatsApp informados.
            </span>
        </v-col>
    </v-container>
</template>

<script>
export default {
    name: "OwnerCreationSuccess"
}
</script>

<style scoped>
.card-content {
    max-width: 680px;
    color: #454545;
    border: 1px solid #7c7c7c;
    border-radius: 16px;
    padding: 2rem;
}
</style>